import { ApiHelper } from './api.helper';
import { IPreInscriptionAcademy } from '../types/pre-inscription-academy.type';
import { HttpUtils } from '../utils/http.utils';
import { IFilters, IRequestParams } from '../views/PreInscriptionsAcademies/types';

export const fetchPreInscriptionsAcademies = async (
  filters: IFilters,
): Promise<IPreInscriptionAcademy[]> => {
  const queryParams = HttpUtils.toQueryParams<IFilters, IRequestParams>(filters);
  const url = `${ApiHelper.makeUrl('pre-inscriptions/academies')}?${queryParams}`;
  const response = await fetch(url, ApiHelper.makeOptions());
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message);
  }

  return data;
};

export const downloadPreInscriptionsAcademies = async (filters: IFilters): Promise<Blob> => {
  const queryParams = HttpUtils.toQueryParams<IFilters, IRequestParams>(filters);
  const url = `${ApiHelper.makeUrl('pre-inscriptions/academies/export')}?${queryParams}`;

  const response = await fetch(url, ApiHelper.makeOptions());
  const data = response.blob();

  if (!response.ok) {
    const responseData = await response.json();

    throw new Error(await responseData.message);
  }

  return data;
};
